import { useState, useEffect } from 'react'

import _ from 'lodash'
import ReactPlayer from 'react-player'

import { Button } from '@/shared/ui/Button'

import { useLevelPlaySurface } from '../surface'

/**
 * Passo de vídeo. O footer é injetado por `setStepsCustomFooters` — o kind
 * controla o próprio CTA, porque a liberação depende de o vídeo ter terminado
 * (ou de um tempo mínimo, quando `next_button_enabled`).
 *
 * A conclusão vai por `onContinue`, que **persiste** o passo no backend antes de
 * avançar. A versão do quiz chamava `onComplete` — que só marca o estado local
 * e, pior, recebia `{ uid }` onde a assinatura espera `{ answer }`, deixando a
 * resposta `undefined`. Resultado: vídeo assistido no quiz não era registrado.
 */
export const LevelPlayVideo = ({ step, activity }) => {
  const { onContinue, isSubmitting, setStepsCustomFooters } =
    useLevelPlaySurface()
  const [canContinue, setCanContinue] = useState(false)
  const { meta } = activity
  const videoUrl = _.get(meta, 'video_url')
  const nextButtonEnabled = _.get(meta, 'next_button_enabled', false)
  const advanceEnabled = _.get(meta, 'advance_enabled', false)

  useEffect(() => {
    if (nextButtonEnabled) {
      setTimeout(() => {
        setCanContinue(true)
      }, 3000)
    }
  }, [nextButtonEnabled])

  useEffect(() => {
    setStepsCustomFooters(
      step.id,
      canContinue ? (
        <Button
          variant="primary"
          className="grow mt-auto"
          showTrailingIcon={false}
          loading={isSubmitting}
          disabled={isSubmitting}
          onClick={() => onContinue({ uid: activity.uid })}
        >
          {isSubmitting ? 'Carregando' : 'Continuar'}
        </Button>
      ) : (
        <Button
          variant="primary"
          className="grow mt-auto"
          showTrailingIcon={false}
          disabled
        >
          {nextButtonEnabled ? 'Continuar' : 'Assista ao vídeo'}
        </Button>
      )
    )
  }, [
    canContinue,
    isSubmitting,
    nextButtonEnabled,
    onContinue,
    setStepsCustomFooters,
    step.id,
    activity.uid
  ])

  return (
    // `overflow-hidden` recorta o player pelo raio do contêiner — técnica do
    // quiz, mais robusta que estilizar o `iframe` por seletor descendente.
    <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden">
      <ReactPlayer
        url={videoUrl}
        controls={advanceEnabled}
        width="100%"
        height="100%"
        loop={false}
        // Sem isto o vídeo abre em tela cheia no iOS, tirando o participante do
        // fluxo do passo. Estava só na jornada.
        playsinline
        onEnded={() => setCanContinue(true)}
        config={{
          youtube: {
            playerVars: {
              autoplay: 0,
              rel: 0,
              showinfo: 0,
              modestbranding: 1,
              disablekb: 1,
              iv_load_policy: 3,
              playsinline: 1
            }
          }
        }}
      />
    </div>
  )
}
